import { inject, Injectable } from '@angular/core';
import { ApiService } from '@geekeno/ngx-website/services';

@Injectable({
  providedIn: 'root',
})
export class BrandkitService {
  private api = inject(ApiService);

  constructor() {}

  createOrder(data: Record<string, string>) {
    return this.api.post<{ id: number; razorpay_order_id: string }>(
      '/brand-kit-orders/',
      data,
    );
  }

  verifyPayment(
    orderId: number,
    data: {
      razorpay_payment_id: string;
      razorpay_order_id: string;
      razorpay_signature: string;
    },
  ) {
    return this.api.post(`/brand-kit-orders/${orderId}/verify-payment/`, data);
  }
}
